import profileImg from "../../assets/IMG_6305.webp";
import mapImg from "../../assets/map.png";
import "./About.css";

export default function About() {
    return (
        <>
        <div className="aboutPage">
            <section className="aboutHero">
                <img 
                src={profileImg} 
                alt="Team collaboration" 
                className="aboutHeroImage"
                />
                <div className="aboutHeroContent">
                    <h1 className="aboutHeroTitle">About</h1>
                    <p className="aboutHeroText">
                        <b>Gulgoleth Mounts</b> was born from my love for hunting and passion for making things. As a hunter, I understand the hard work and dedication that goes into every hunt. I believe that every experience in the field is worth preserving. That’s why I'm dedicated producing high-quality euro mounts, ensuring you have a trophy you can proudly display.
                    </p>
                    <p className="aboutHeroText">
                        Gulgoleth (<i>gul-go'-leth</i>) is a Hebrew word that translates to 'head' or 'skull.' It is the origin of the name Golgotha, which means 'the place of the skull'—the site where Jesus sacrificed his life for us (Mark 15:22).
                    </p>
                </div>
            </section>

            <div className="aboutContainer">
                <section className="aboutSection">
                    <h2 className="aboutSectionTitle">Our Location</h2>
                    <img 
                    src={mapImg} 
                    alt="Team collaboration" 
                    className="aboutSectionImage"
                    />
                    <p className="aboutSectionText">
                        We're located in New Franklin, Missouri. We serve the surrounding Columbia and Boonville area, however we welcome clients from all over!
                    </p>
                    <p className="aboutSectionText">
                        <strong>Email:</strong> gulgolethmounts@gmail.com
                    </p>
                </section>
            </div>
        </div>
        </>
    );
}